export default "__VITE_ASSET__DdT7ozgu__"